import { render, staticRenderFns } from "./DragAndDropTable.vue?vue&type=template&id=b46227f0&scoped=true&"
import script from "./DragAndDropTable.vue?vue&type=script&lang=ts&"
export * from "./DragAndDropTable.vue?vue&type=script&lang=ts&"
import style0 from "./DragAndDropTable.vue?vue&type=style&index=0&id=b46227f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46227f0",
  null
  
)

export default component.exports